import isJWT from "validator/es/lib/isJWT";
import { z } from "zod";

export const searchParser = z.object({
  t: z.coerce.string().refine(isJWT).optional().catch(""),
  redirect: z.string().optional().catch(""),
  token_set: z.boolean().optional().catch(false),
  error: z.string().optional().catch(""),
});
